// extracted by mini-css-extract-plugin
export var avatar = "_nu-3";
export var avatarContainer = "_nu-2";
export var avatarSpacer = "_nu-5";
export var avatarSpacerContainer = "_nu-4";
export var avatarStackContainer = "_nu-1";
export var bubble = "_nu-0";
export var remainderBubble = "_nu-6";